import request from "../utils/request";
export async function setPrinterSetting(setting){
  return request.put("PrinterSetting",setting);
}
export async function getPrinterSetting(){
  return request.get("PrinterSetting");
}
